import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-breadcrumb",
  "use": "icon-breadcrumb-usage",
  "viewBox": "0 0 5 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 5 8\" id=\"icon-breadcrumb\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m1.216 4 3.45 3.223L4.03 8 .164 4.388A.532.532 0 0 1 0 4c0-.149.06-.29.165-.388L4.03 0l.636.777L1.216 4Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol